// src/components/DropdownButton.tsx
import React, { useState } from 'react'
import styled from '@emotion/styled'
import { motion, AnimatePresence } from 'framer-motion'

export interface DropdownButtonProps {
  trigger: React.ReactNode | (({ open }: { open: boolean }) => React.ReactNode)
  children: React.ReactNode
  closeOnClick?: boolean
}

const DropdownButton: React.FC<DropdownButtonProps> = ({ trigger, children, closeOnClick = false }) => {
  const [open, setOpen] = useState(false)
  const buttonId = React.useId()
  const panelId = React.useId()

  const handleToggle = () => {
    setOpen(prev => !prev)
  }

  const handlePanelClick = () => {
    if (closeOnClick) {
      setOpen(false)
    }
  }

  return (
    <Wrapper>
      <DropdownButtonStyled
        type="button"
        onClick={handleToggle}
        aria-expanded={open}
        aria-controls={panelId}
        id={buttonId}
      >
        {typeof trigger === 'function' ? trigger({ open }) : trigger}
      </DropdownButtonStyled>

      <AnimatePresence initial={false}>
        {open && (
          <DropdownContent
            key="dropdown"
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.2 }}
            role="region"
            id={panelId}
            aria-labelledby={buttonId}
            onClick={handlePanelClick}
          >
            {children}
          </DropdownContent>
        )}
      </AnimatePresence>
    </Wrapper>
  )
}

const Wrapper = styled.div``

const DropdownButtonStyled = styled.button`
  width: 100%;

  &[aria-expanded='true'] {
    & > div > p {
      font-weight: var(--medium);
    }
  }
`

const DropdownContent = styled(motion.div)``

export default DropdownButton
